import { trashBinOutline } from 'ionicons/icons';
import { ReactElement } from 'react';
import { WithConfirmation } from '../../../../../../components/button/with-confirmation';
import { getLocalizedText } from '../../../../../../i18n/i18n.utils';
import {
  FlowItemBaseAction,
  FlowItemBaseActionCommonProps,
} from './flow-item-base-action';

interface FlowItemDeleteActionProps extends FlowItemBaseActionCommonProps {
  icon?: string;
  label?: string;
  color?: string;
}

const FlowItemDeleteAction = (
  props: FlowItemDeleteActionProps
): ReactElement => {
  const { onClick, disabled, label, icon, color } = props;

  return (
    <WithConfirmation
      // TODO - this prompt is always plural, but there could be a single item in the array
      // ... it'd be better to have a singular and plural version of this prompt
      header={getLocalizedText('common:discard_confirmation')}
    >
      {({ onConfirmed }) => (
        <FlowItemBaseAction
          color={color ?? 'var(--ion-color-danger)'}
          icon={icon ?? trashBinOutline}
          label={label ?? getLocalizedText('common:delete')}
          onClick={() => {
            onConfirmed({ onConfirmation: onClick });
          }}
          disabled={disabled}
        />
      )}
    </WithConfirmation>
  );
};

export { FlowItemDeleteAction };
